const myAvatar = async (root, args, context) => {
  const {
    userId
  } = args;
  const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
  return context.fetch(url).then(data => data.json());
};
export default myAvatar;